import { setDialog } from "components/features/Corp/CorpUser.Slice";
import { useTranslate } from "hooks/useTranslate";
import { useDispatch } from "react-redux";
import { useAppSelector } from "redux/hooks";
import { FEEDBACK_TIMER, messageTypes, messages } from "utils/CommonConstants";
import { editList } from "utils/CommonFunctions";
import Feedback from "../Feedback";

export default function Snackbar() {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const feedbackDetail: any = useAppSelector((state) => state.snackbarDetails.feedbackDetails);
  const listCreatedSuccess = useAppSelector((state) => state.CorpDashboard.listCreatedSuccess);
  const listCategory = useAppSelector((state) => state.CorpDashboard.myListsSelected.listCategory);
  const selectedList = useAppSelector((state) => state.CorpDashboard.myListsSelected.selectedList);

  const getMessage = (messageType: string) => {
    switch (messageType) {
      case messageTypes.singleOwner:
      case messageTypes.multipleOwners: {
        return `Contact ${
          feedbackDetail?.displayName ? feedbackDetail?.displayName : ""
        }, the Plan Member who is the Owner to request changes.`;
      }
      default: {
        return `Modifications can't be made. This is preconfigured to ensure a successful and on-time implementation.`;
      }
    }
  };

  const clickHandler = () => {
    const type = listCategory === "consultant" ? "sc" : "static";
    if (listCategory === "consultant" || listCategory === "static") {
      editList(selectedList, type);
    } else {
      dispatch(setDialog({ dialogName: "renameList", isOpen: true, data: selectedList }));
    }
  };

  return (
    <>
      <Feedback form="deletePlan" message="This has been deleted." />
      <Feedback form="removeInvitee" message={translate("myPlan.memberRemoval")} />
      <Feedback form="deleteList" message={messages.listDeleteSuccess} />
      <Feedback
        form="duplicateFilter"
        message={"List was successfully duplicated!"}
        linkLabel="Rename List"
        clickHandler={clickHandler}
      />
      <Feedback
        form=""
        actionStatus={{ shouldShow: listCreatedSuccess.isCreated, variant: "success", timer: FEEDBACK_TIMER }}
        message={listCreatedSuccess.message}
      />
      <Feedback
        form=""
        actionStatus={{
          shouldShow: feedbackDetail?.shouldShow,
          variant: feedbackDetail?.variant ? feedbackDetail?.variant : "error",
          setState: feedbackDetail?.setState,
          timer: FEEDBACK_TIMER
        }}
        message={feedbackDetail?.message ? feedbackDetail?.message : getMessage(feedbackDetail?.messageType)}
      />
    </>
  );
}
